import { Box, Button, Table, Typography } from "@qws-org/ui-kit";
import type { FC } from "react";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import type { ScheduleDate, TransformerSchedule } from "~/core";
import { formatDateToShortMonth } from "~/shared/utils/format-date";

export const ScheduleTable: FC<{ spreadsheet: TransformerSchedule }> = ({
  spreadsheet,
}) => {
  const spreadSheetKeys = Object.keys(spreadsheet);
  const [activeDate, setActiveDate] = useState<ScheduleDate>(
    spreadSheetKeys[0],
  );

  return (
    <Box
      minWidth={328}
      width="100%"
      md={{ maxWidth: 640 }}
      d={{ maxWidth: 690 }}
      data-testid="schedule-table"
    >
      <Swiper
        breakpoints={{
          768: {
            spaceBetween: 8,
          },
          340: { spaceBetween: 4 },
        }}
        slidesPerView="auto"
        grabCursor={true}
        scrollbar={{ hide: true }}
        className="mb-10 md:mx-[27px]"
      >
        {spreadsheet &&
          spreadSheetKeys.map((item) => (
            <SwiperSlide
              key={item}
              onClick={() => {
                setActiveDate(item);
              }}
              className="max-w-fit cursor-grab transition-colors duration-300"
            >
              <Button
                maxWidth="fit-content"
                p={{ px: 16, py: 8 }}
                key={item}
                variant="secondary"
                isActive={item === activeDate}
              >
                <Typography
                  color={item === activeDate ? "text-selection" : ""}
                  className="transition-colors duration-300 "
                >
                  {formatDateToShortMonth({
                    day: +item.split(".")[0],
                    month: +item.split(".")[1],
                    year: +item.split(".")[2],
                  })}
                </Typography>
              </Button>
            </SwiperSlide>
          ))}
      </Swiper>
      <Table aria-label="Schedule table">
        <Table.Header>
          <Table.Column>
            <Typography
              fontWeight="mobile.normal"
              size="small"
              md={{
                fontWeight: "desktop.semibold",
                fontSize: "body.desktop.small",
                lineHeight: "body.desktop.large",
              }}
              p={{ py: 12 }}
              horizontalAlign="center"
              color="text-secondary-default"
            >
              Time
            </Typography>
          </Table.Column>
          <Table.Column> </Table.Column>
          <Table.Column>
            <Typography
              fontWeight="mobile.normal"
              size="small"
              md={{
                fontWeight: "desktop.semibold",
                fontSize: "body.desktop.small",
                lineHeight: "body.desktop.large",
              }}
              p={{ py: 12 }}
              horizontalAlign="center"
              color="text-secondary-default"
            >
              BuyIn
            </Typography>
          </Table.Column>
          <Table.Column>
            <Typography
              fontWeight="mobile.normal"
              size="small"
              md={{
                fontWeight: "desktop.semibold",
                fontSize: "body.desktop.small",
                lineHeight: "body.desktop.large",
              }}
              p={{ py: 12 }}
              horizontalAlign="center"
              color="text-secondary-default"
            >
              GTD, U$
            </Typography>
          </Table.Column>
        </Table.Header>
        <Table.Body>
          {spreadsheet[activeDate].map((item) => (
            <Table.Row key={item.id}>
              <Table.Cell>
                <Typography
                  color="text-accent-default"
                  size="small"
                  md={{ size: "medium" }}
                >
                  {item.time}
                </Typography>
              </Table.Cell>
              <Table.Cell>
                <Typography size="small" md={{ size: "medium" }}>
                  {item.eventName}
                </Typography>
              </Table.Cell>
              <Table.Cell>
                <Typography size="small" md={{ size: "medium" }}>
                  {item.buyIn}
                </Typography>
              </Table.Cell>
              <Table.Cell>
                <Typography size="small" md={{ size: "medium" }}>
                  {item.gtd}
                </Typography>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Box>
  );
};
